import React, { useState, useEffect, useRef } from 'react';
import { Modal, Pagination, Input } from 'antd';
import styles from './upload-asset-modal.module.css';
import { UploadAsset } from './UploadAsset';
import { initializeApollo } from '@src/apolloClient';

const client = initializeApollo();

export default function UploadAssetModal({
  isVisible,
  setIsVisible,
  userEmail,
  callback,
}) {
  const [loading, setLoading] = React.useState(false);
  return (
    <Modal
      maskClosable={!loading}
      open={isVisible}
      closable={!loading}
      onCancel={() => {
        setIsVisible(false);
      }}
      footer={null}
      centered
      destroyOnClose
      zIndex={1010}
      width={700}
      className={styles.modal}
    >
      <div className={styles.modalContent}>
        <UploadAsset
          userEmail={userEmail}
          callback={callback}
          onCloseModal={() => {
            setIsVisible(false);
          }}
          loading={loading}
          setLoading={setLoading}
        ></UploadAsset>
      </div>
    </Modal>
  );
}
